import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Pagination from "../../components/Pagination.tsx";
import { getCampaignRequest } from "../../services/Campaigns.ts";

interface UserRequest {
  id: number;
  user_name: string;
  user_email: string;
  status: "Pending" | "Approved" | "Rejected";
}

const UserRequests: React.FC = () => {
  const { campaignId } = useParams<{ campaignId: string }>(); // Get campaign ID from URL
  const [requests, setRequests] = useState<UserRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const {id} = useParams();

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const rawData = localStorage.getItem('user');
        const cred = rawData ? JSON.parse(rawData) : null;
        const token = cred?.access;

        if (!token || !id) {
          console.error("Missing token or id");
          setLoading(false);
          return;
        }

        const response = await getCampaignRequest(token, id);
        if(response && response.status === 200){
          setRequests(response.data);
        }
      } catch (error) {
        console.error("Error fetching user requests:", error);
      }
      setLoading(false);
    };

    fetchRequests();
  }, [id]);

  const updateRequestStatus = (id: number, newStatus: "Approved" | "Rejected") => {
    setRequests((prevRequests) =>
      prevRequests.map((req) =>
        req.id === id ? { ...req, status: newStatus } : req
      )
    );
    // TODO: Send API request to update status in backend
  };

  const deleteRequest = (id: number) => {
    setRequests((prevRequests) => prevRequests.filter((req) => req.id !== id));
    // TODO: Send API request to delete request from backend
  };

  return (
    <div className="min-h-[80vh] bg-gray-100 flex justify-center">
      <div className="w-full max-w-5xl bg-white p-6 rounded-lg shadow-lg border-2 border-primary-400">
        {/* <h2 className="text-2xl font-bold text-primary-700 text-center">
          User Requests for Campaign #{campaignId}
        </h2> */}

        {loading ? (
          <div className="flex justify-center items-center mt-6">
            <div className="loader border-t-4 border-primary-600 rounded-full w-12 h-12 animate-spin"></div>
            <p className="ml-4 text-primary-700">Loading requests...</p>
          </div>
        ) : requests.length === 0 ? (
          <p className="text-center text-gray-500 mt-4">No requests found.</p>
        ) : (
          <div className="overflow-x-auto mt-4">
            <table className="w-full border-collapse border border-gray-200">
              <thead>
                <tr className="bg-primary-500 text-white">
                  <th className="p-3 border border-gray-300">Name</th>
                  <th className="p-3 border border-gray-300">Email</th>
                  <th className="p-3 border border-gray-300">Status</th>
                  <th className="p-3 border border-gray-300">Actions</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request) => (
                  <tr key={request.id} className="text-gray-700 bg-gray-50 hover:bg-gray-100">
                    <td className="p-3 border border-gray-300">{request.user_name}</td>
                    <td className="p-3 border border-gray-300">{request.user_email}</td>
                    <td className="p-3 border border-gray-300">
                      <span
                        className={`px-2 py-1 rounded text-white ${
                          request.status === "Approved"
                            ? "bg-green-500"
                            : request.status === "Pending"
                            ? "bg-yellow-500"
                            : "bg-red-500"
                        }`}
                      >
                        {request.status}
                      </span>
                    </td>
                    <td className="p-3 border border-gray-300 flex gap-2">
                      {request.status === "Pending" && (
                        <>
                          <button
                            onClick={() => updateRequestStatus(request.id, "Approved")}
                            className="px-3 py-1 text-sm bg-green-500 text-white rounded hover:bg-green-600"
                          >
                            Accept
                          </button>
                          <button
                            onClick={() => updateRequestStatus(request.id, "Rejected")}
                            className="px-3 py-1 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600"
                          >
                            Reject
                          </button>
                        </>
                      )}
                      <button
                        onClick={() => deleteRequest(request.id)}
                        className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination currentPage={1} totalPages={1} onPageChange={() => {}} />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserRequests;
